import { render, staticRenderFns } from "./getpwd.vue?vue&type=template&id=828a3d32&scoped=true"
import script from "./getpwd.vue?vue&type=script&lang=js"
export * from "./getpwd.vue?vue&type=script&lang=js"
import style0 from "./getpwd.vue?vue&type=style&index=0&id=828a3d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828a3d32",
  null
  
)

export default component.exports